import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import Modal from 'react-bootstrap/Modal'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'

function VehicalModel(props) {
  const { setShow, show, vehiclename, handelOtherVehicleAdd, handelOtherVehicleClose } = props
  const {
    handleSubmit,
    formState: { errors },
    control,
    getValues
  } = useForm()
  const handleClose = () => {
    handelOtherVehicleClose(vehiclename)
    setShow(false)
  }

  const onSubmit = () => {
    handelOtherVehicleAdd(getValues())
  }



  return (
    <Modal show={show} onHide={handleClose}>

      {/* <Modal.Header closeButton> <Modal.Title>{vehiclename ? vehiclename.charAt(0).toUpperCase() + vehiclename.slice(1).toLowerCase():'Other'} </Modal.Title> </Modal.Header> */}
      <Modal.Header closeButton> <Modal.Title>{vehiclename == 'make' ? 'Make/Model' : 'Model'} </Modal.Title> </Modal.Header>

      <Modal.Body>
        <div className="mb-3 ">

          <form onSubmit={handleSubmit(onSubmit)}>

            <div className="row g-1">

              {/* <input type='text' placeholder='hello' name={name} className='form-control'/>  */}
              {vehiclename == 'make' && <div className="col">
                <Controller
                  name={vehiclename}
                  type="text"
                  id={vehiclename}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'This field is required',
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      id={vehiclename}
                      title={vehiclename ? vehiclename.charAt(0).toUpperCase() + vehiclename.slice(1).toLowerCase() : ''}
                      // unmask
                      // rtl
                      className="form-control flex-grow-1"
                      placeholder={vehiclename ? vehiclename.charAt(0).toUpperCase() + vehiclename.slice(1).toLowerCase() : ''}
                    />
                  )}
                />
                {errors?.make && (
                  <span className="text-danger small">
                    {errors?.make?.message}
                  </span>
                )}
              </div>}

              {vehiclename == 'make' || vehiclename == 'model' ?
                <div className="col"> <Controller
                  name='model'
                  type="text"
                  id='model'
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: 'This field is required',
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      id='model'
                      title='Model'
                      // unmask
                      // rtl
                      className="form-control flex-grow-1"
                      placeholder='Model'
                    />
                  )}
                />
                  {errors?.model && (
                    <span className="text-danger small">
                      {errors?.model?.message}
                    </span>
                  )}
                </div> : ''
              }

              <div className="col-auto">
                <button type='submit' className='btn btn-primary'>Submit</button>
              </div>
              <div className="col-auto">
                <button type='button' onClick={handleClose} className='btn btn-danger' name='Close' role='button' >Close</button>
              </div>


            </div>






          </form>



        </div>
      </Modal.Body>
    </Modal>
  )
}

VehicalModel.propTypes = {
  dispatch: PropTypes.func,
  setShow: PropTypes.func,
  show: PropTypes.bool,
  vehiclename: PropTypes.string,
  handelOtherVehicleAdd: PropTypes.func,
  handelOtherVehicleClose: PropTypes.func,
}

VehicalModel.defaulProps = {
  dispatch: noop,
  setShow: noop,
  show: false,
  vehiclename: '',
  handelOtherVehicleAdd: noop,
  handelOtherVehicleClose: noop,
}

function mapStateToProps({ userDetailsReducer }) {
  return {
    loader: userDetailsReducer?.loader,
    loaderSms: userDetailsReducer?.loaderSms,
    loaderDownload: userDetailsReducer?.loaderDownload,
  }
}
export default connect(mapStateToProps)(VehicalModel) 